/* global analytics */

import React, { Component } from "react";

export default class ShareCopy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            copiedClasses: "smb__copied smb__copied--hidden"
        }

        this.textAreaRef = React.createRef();
    }

    handleClick = (evt) => {
        this.textAreaRef.current.select();
        document.execCommand('copy');
        this.animateCopiedText(evt.target.className);
        // segment tracking on click
        analytics.track('Clicked Element', {
            element_name: 'Copy to Clipboard Share'
        });
    }

    animateCopiedText = (className) => {
        if (className === "smb__copied fadeIn") {
            return;
        }
        this.setState({
            copiedClasses: "smb__copied fadeIn",
        })
        setTimeout(()=>{
            this.setState({
                copiedClasses: "smb__copied smb__copied--hidden",
            })
        }, 1900)
    }
    render(){
        let {url} = this.props;
        return (
            <div 
                className="smb__icon smb__icon--copy" 
                onClick={this.handleClick}
                title="Copy to Clipboard"
            >
            <i className="fal fa-copy"></i>
            <textarea
                className="smb__hidden-ta"
                ref={this.textAreaRef}
                value={url} 
                readOnly
            />
            <div className={this.state.copiedClasses}>Copied!</div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/ShareMyBox/ShareCopy/ShareCopy.js